<template lang="pug">
	#menu-header
		.menu
			.flex-item
				.left
					.home(v-on:click="goHome()")
						.logo-image
						el-divider(direction="vertical")
						.logo-ipaam
			.right
				.flex-item
					.locale 
						.logout
							i.mdi.mdi-logout(v-if="usuarioLogado()" v-on:click="logout()") 	
</template>

<script>
import { CANCELAR, USUARIO_LOGOUT } from "../../store/actions.type";

export default {
  name: "MenuHeader",
  mixins: [],
  props: ["index"],
  methods: {
    goHome() {
      this.$store.dispatch(CANCELAR).then(p => {
        this.$router.push({ name: "home" });
      });
    },

    logout() {
      this.$store.dispatch(USUARIO_LOGOUT).then(() => {
        this.$router.push({ name: "login" });
      });
    },
    usuarioLogado() {
      return this.$store.getters["usuarioLogado"];
    }
  }
};
</script>

<style lang="sass">
@import "../../theme/tools/variables"

@import url('https://fonts.googleapis.com/css?family=Lato:900')

#menu-header
	width: 100%
	height: 100%

	.menu
		display: flex
		align-items: center
		height: 100%
		padding: 0 20px 0 20px
		justify-content: space-between
		box-shadow: 0 4px 4px rgba(0, 0, 0, .1)
		background-color: #295661

		.left
			display: flex
			align-items: center

			.home
				display: flex
				align-items: center
				text-decoration: none
				cursor: pointer

		.flex-item
			flex: 1
			display: grid

			.logo-image
				color: white
				height: 3.75rem
				width: 170px
				background: url("../../assets/logoAm.png") no-repeat center
				background-size: contain

			.el-divider
				height: 3.75rem
				margin: 0 20px

			.logo-ipaam
				color: white
				height: 3.75rem
				width: 170px
				background: url("../../assets/logoIpaam.png") no-repeat center
				background-size: contain

			.logo-text
				padding-left: 20px
				font-family: "Lato", Helvetica, sans-serif
				font-weight: bold
				color: black
				font-size: $--fonte-titulo
				border-left: 1px solid #999
				.completo
					font-size: 12px
					width: 190px
				.sigla
					font-size: 19px

		.right
			display: flex
			align-items: center

			.locale
				display: flex
				align-items: center
				justify-content: flex-end

				i
					color: $--cor-botao-secundario
					font-size: $--fonte-titulo
					padding-right: 0

				.el-input__inner
					border: none

				.el-select
					width: 90px
		.left-t
			display: flex
			align-items: center

			.locale
				display: flex
				align-items: center

				i
					color: $--cor-botao-secundario
					font-size: $--fonte-titulo
					padding-right: 0

				.el-input__inner
					border: none

				.el-select
					width: 90px

	.el-menu--horizontal .el-menu .el-menu-item.is-active, .el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title
		color: #409EFF !important

	.el-menu--horizontal .el-menu .el-menu-item
		color: #409EFF !important
		font-size: 15px !important

	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal .el-menu-item:not(.is-disabled):focus
		background-color: #f5f7fa

	.el-menu--horizontal .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal .el-menu-item:not(.is-disabled):focus
		color: #409EFF !important

	.el-menu--horizontal > .el-submenu .el-submenu__title
		font-size: 16px
		height: 53px
		color: black
		font-weight: bold

	.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow
		color: #409EFF !important
		font-size: 24px
		padding-right: 0


	.el-menu.el-menu--horizontal
		border-bottom-color: #fff !important

	.el-submenu.is-active .el-submenu__title
		border-bottom-color: #fff !important

	.logout
		cursor: pointer

	@media screen and (max-width: 600px)
		.menu
			padding: 0 10px 0 5px	!important
		.logo-image
				height: 80px !important
				width: 120px !important
				margin-right: 0px !important
				margin-left: 0px !important
		.logo-text
			.completo
				font-size: 9px !important
				width: 120px !important
			.sigla
				font-size: 19px
		.right
			width: 100px !important
			padding-right: 5vw !important
			.locale
				i
					color: $--cor-texto-secundario
					font-size: 16px !important
					padding-right: 0

				.el-input__inner
					border: none

				.el-select
					width: 85px !important
</style>
